module.exports = __webpack_public_path__ + "img/load-5-2.0e369fdd.png";